/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import { getIndustries } from "api";
import debounce from "lodash.debounce";
import MDButton from "components/MDButton";
import { deleteIndustry } from "api";
import MDInput from "components/MDInput";
import { createIndustry } from "api";
import { updateIndustry } from "api";
import { exportToExcel } from "utilities";
import { notify } from "utilities";

export default function data({}) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmAdd, setOpenConfirmAdd] = useState(false);
  const [industry, setIndustry] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "active", name: "Active" },
    { key: "inactive", name: "Inactive" },
  ];
  const [status, setStatus] = useState(arrStatus[0]);

  useEffect(() => {
    onSearchData("");
  }, []);

  useEffect(() => {
    if (search !== undefined) {
      getIndustriesApi();
    }
  }, [search]);

  useEffect(() => {}, [status]);

  const debouncedFetch = useRef(
    debounce((searchVal) => {
      setSearch(searchVal);
    }, 500)
  ).current;

  const getIndustriesApi = (isReset = false) => {
    var params = {
      page: 1,
      limit: 1000,
      name: search,
    };

    if (isReset) {
      params.type = "all";
    } else {
      params.type = status?.key || "all";
    }

    setLoading(true);

    getIndustries({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setList(responseJson?.industry);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const onSearchData = (val) => {
    debouncedFetch(val);
  };

  const handleAction = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRowId(rowId);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    // setCurrentRowId(null);
  };

  const JobIndustry = ({ name, detail }) => (
    <MDBox display="flex" gap={2}>
      <MDBox>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          noWrap
          sx={{
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = () => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      {
        Header: "status",
        accessor: "status",
        align: "center",
      },
      {
        Header: "actions",
        accessor: "actions",
        align: "center",
      },
    ];
  };

  const handleStatus = (item) => {
    setLoadingId(item?._id);
    var params = {
      isActive: item?.isActive ? false : true,
    };
    updateIndustryApi(params, item?._id);
    // const updatedUsers = list.map((u) =>
    //   u._id.toString() === user.id.toString() ? { ...u, isActive: !u.isActive } : u
    // );
    // setList(updatedUsers);
  };

  const oneEditClick = () => {
    closeMenu();
    setIndustry(list.find((item) => item._id === currentRowId)?.name || "");
    setOpenConfirmAdd(true);
  };
  const onDeleteClick = () => {
    // Implement delete functionality here
    closeMenu();
    setOpenConfirm(true);
  };

  const renderActionMenu = (rowId) => (
    <Menu
      id={`simple-menu-${rowId}`}
      anchorEl={menuAnchor}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor) && currentRowId === rowId}
      onClose={closeMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>mode_edit</Icon>} title="Edit" onClick={oneEditClick} />
      <NotificationItem
        icon={<Icon>delete</Icon>}
        title={
          <>
            <span style={{ color: "red" }}>Delete</span>
          </>
        }
        onClick={onDeleteClick}
      />
    </Menu>
  );

  const rows = () => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: <JobIndustry name={item?.name} />,
        status: (
          <MDBox sx={{ px: 1 }}>
            {loadingId === item?._id ? (
              <CircularProgress size={24} color="success" />
            ) : (
              <Switch
                checked={item?.isActive}
                onChange={() => handleStatus(item)}
                color="success"
              />
            )}
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ px: 1 }} onClick={(e) => handleAction(e, item?._id)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">more_vert</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  };

  const confirmDialog = () => {
    return (
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this industry? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="error" variant="contained">
            Cancel
          </Button>
          <MDButton onClick={handleDelete} color="error">
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const confirmDialogAdd = () => {
    return (
      <Dialog open={openConfirmAdd} onClose={() => setOpenConfirmAdd(false)}>
        <DialogTitle>Industry</DialogTitle>
        <DialogContent>
          <MDBox display="flex" gap={2} mt={2} width="17rem">
            <MDInput
              label={
                <>
                  Industry
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              type="text"
              fullWidth
              value={industry}
              onChange={(e) => setIndustry(e.target.value)}
              sx={{ mb: 2 }}
              helperText={isSubmitted && !industry ? "Industry is required" : ""}
              FormHelperTextProps={{
                sx: {
                  color: "red",
                  marginLeft: "0",
                },
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmAdd(false);
              setIsSubmitted(false);
              setIndustry("");
            }}
            color="error"
            variant="contained"
          >
            Cancel
          </Button>
          <MDButton onClick={handleAdd} color="success">
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const handleAdd = () => {
    if (industry.trim() === "") {
      setIsSubmitted(true);
    } else {
      setIsSubmitted(false);
      if (currentRowId) {
        var params = {
          name: industry,
        };
        updateIndustryApi(params, currentRowId);
      } else {
        createIndustryApi();
      }
    }
  };

  const handleDelete = () => {
    setOpenConfirm(false);

    deleteIndustryApi();
  };

  const deleteIndustryApi = () => {
    var params = {};

    deleteIndustry({
      params: params,
      id: currentRowId,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            getIndustriesApi();
          }
        }
      })
      .catch((e) => {});
  };

  const updateIndustryApi = (params, id) => {
    updateIndustry({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            setOpenConfirmAdd(false);
            setIndustry("");
            getIndustriesApi();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoadingId(null);
      });
  };

  const createIndustryApi = async () => {
    var params = {
      name: industry,
    };

    createIndustry({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            setOpenConfirmAdd(false);
            setIndustry("");
            getIndustriesApi();
          }
        }
      })
      .catch((e) => {});
  };

  const onPressAdd = () => {
    setCurrentRowId(null);
    setOpenConfirmAdd(true);
  };

  const handleApplyFilter = () => {
    getIndustriesApi();
  };
  const handleResetFilter = () => {
    setStatus(arrStatus[0]);
    getIndustriesApi(true);
  };

  const handleExport = () => {
    exportToExcel(list, "industry.xlsx");
  };

  const ViewFilter = () => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Status"
              value={JSON.stringify(status)}
              onChange={(e) => setStatus(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            >
              {arrStatus.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
        </MDBox>
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} color="success">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  };

  return (
    <MDBox>
      <ViewFilter />
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns: columns(), rows: rows() }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            noEndBorder
            onSearch={(val) => {
              onSearchData(val);
            }}
            canAdd={{
              onClick: onPressAdd,
              label: "Add",
            }}
          />
          {list.map((item) => renderActionMenu(item?._id))}

          {confirmDialog()}

          {confirmDialogAdd()}

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="success" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
